import { component } from 'picoapp'
import $ from '../lib/quantdom'

export default component((node) => {
  $(node)
    .find('.js-plus')
    .on('click', async (e) => {
      const val = parseInt($(e.target).parent().find('.js-quantity').val())
      const newVal = val + 1
      $(e.target).parent().find('.js-quantity').val(newVal)
      $('add-button#main-add-to-cart').attr('quantity', newVal)
      $('.dynamic-payment-button input[name="quantity"]').val(newVal) //used for dynamic payment/buy now button
    })

  $(node)
    .find('.js-minus')
    .on('click', async (e) => {
      const val = parseInt($(e.target).parent().find('.js-quantity').val())
      if (val > 1) {
        const newVal = val - 1
        $(e.target).parent().find('.js-quantity').val(newVal)
        $('add-button#main-add-to-cart').attr('quantity', newVal)
        $('.dynamic-payment-button input[name="quantity"]').val(newVal) //used for dynamic payment/buy now button
      }
    })
})
